// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-hub-page {
  min-height: 100vh;
  min-height: 100dvh;
  padding:
    calc(18px + var(--app-safe-top, 0px))
    calc(18px + var(--app-safe-right, 0px))
    calc(36px + var(--app-safe-bottom, 0px))
    calc(18px + var(--app-safe-left, 0px));
  position: relative;
  overflow-x: hidden;
  color: #f5f0e5;
  background:
    radial-gradient(circle at top center, rgba(53, 109, 92, 0.26) 0%, rgba(7, 19, 27, 0) 34%),
    radial-gradient(circle at 20% 80%, rgba(240, 202, 115, 0.1) 0%, rgba(7, 19, 27, 0) 28%),
    linear-gradient(180deg, #07131b 0%, #0b1d29 52%, #04080c 100%);
}

.wallet-hub-page__texture {
  position: fixed;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.015) 1px, transparent 1px);
  background-size: 18px 18px;
  mask-image: radial-gradient(circle at center, rgba(0, 0, 0, 0.88) 35%, transparent 100%);
  opacity: 0.65;
}

.wallet-hub-topbar,
.wallet-hub-main {
  position: relative;
  z-index: 1;
}

.wallet-hub-topbar {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.wallet-hub-topbar__back,
.wallet-hub-topbar__logout,
.wallet-hub-summary__card,
.wallet-hub-action {
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(180deg, rgba(14, 24, 31, 0.94) 0%, rgba(8, 15, 22, 0.98) 100%);
  color: #f5f0e5;
  border-radius: 22px;
}

.wallet-hub-topbar__back {
  min-height: 42px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.84rem;
  cursor: pointer;
}

.wallet-hub-topbar__logout {
  min-height: 42px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.84rem;
  cursor: pointer;
}

.wallet-hub-main {
  display: grid;
  gap: 14px;
}

.wallet-hub-summary__card span {
  color: #f0ca73;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.62rem;
}

.wallet-hub-banner {
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid transparent;
}

.wallet-hub-banner--error {
  color: #ffd3cc;
  background: rgba(255, 127, 114, 0.08);
  border-color: rgba(255, 127, 114, 0.18);
}

.wallet-hub-summary {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
}

.wallet-hub-summary__card {
  padding: 16px;
  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.28);
}

.wallet-hub-summary__card--club {
  display: grid;
  gap: 12px;
}

.wallet-hub-summary__club,
.wallet-hub-summary__wallet {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.wallet-hub-summary__club span,
.wallet-hub-summary__wallet span {
  color: #f0ca73;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-size: 0.62rem;
}

.wallet-hub-summary__club strong {
  font-size: 0.96rem;
  line-height: 1.2;
  text-align: right;
}

.wallet-hub-summary__wallet strong {
  font-size: clamp(1.1rem, 3.8vw, 1.5rem);
  line-height: 1.1;
  text-align: right;
}

.wallet-hub-actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.wallet-hub-action {
  width: 100%;
  min-height: 76px;
  padding: 14px;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.28);
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.wallet-hub-action:hover,
.wallet-hub-action:focus-visible {
  transform: translateY(-1px);
  border-color: rgba(49, 230, 164, 0.22);
  box-shadow: 0 22px 38px rgba(0, 0, 0, 0.34);
}

.wallet-hub-action__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
}

.wallet-hub-action__icon svg,
.wallet-hub-action > svg {
  width: 18px;
  height: 18px;
}

.wallet-hub-action__icon--deposit {
  color: #31e6a4;
}

.wallet-hub-action__icon--withdraw {
  color: #f0ca73;
}

.wallet-hub-action__copy {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.wallet-hub-action__copy strong {
  font-size: 0.96rem;
  line-height: 1.1;
  letter-spacing: -0.01em;
}

.wallet-hub-action__copy span {
  color: rgba(233, 238, 241, 0.64);
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.14em;
}

.wallet-hub-action > svg:last-child {
  color: rgba(233, 238, 241, 0.62);
}

.wallet-hub-action p {
  display: none;
}

.wallet-hub-action--deposit {
  border-color: rgba(49, 230, 164, 0.22);
}

.wallet-hub-action--withdraw {
  border-color: rgba(240, 202, 115, 0.18);
}

@media (max-width: 720px) {
  .wallet-hub-page {
    padding:
      calc(12px + var(--app-safe-top, 0px))
      calc(12px + var(--app-safe-right, 0px))
      calc(18px + var(--app-safe-bottom, 0px))
      calc(12px + var(--app-safe-left, 0px));
  }

  .wallet-hub-topbar {
    margin-bottom: 12px;
  }

  .wallet-hub-topbar__back,
  .wallet-hub-topbar__logout {
    min-height: 40px;
    padding: 0 12px;
    font-size: 0.8rem;
  }

  .wallet-hub-hero h1 {
    font-size: clamp(1.3rem, 5.8vw, 1.85rem);
  }

  .wallet-hub-action {
    min-height: 72px;
    padding: 12px;
    grid-template-columns: 32px minmax(0, 1fr) auto;
  }

  .wallet-hub-action__icon {
    width: 32px;
    height: 32px;
    border-radius: 11px;
  }

  .wallet-hub-action__copy strong {
    font-size: 0.92rem;
  }

  .wallet-hub-action__copy span {
    font-size: 0.68rem;
  }

  .wallet-hub-summary__card {
    padding: 14px;
  }

  .wallet-hub-summary__club strong {
    font-size: 0.9rem;
  }

  .wallet-hub-summary__wallet strong {
    font-size: 1.15rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ClubWalletHubPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB;;;;0CAIwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd;;;kEAGgE;AAClE;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB;;2EAEyE;EACzE,0BAA0B;EAC1B,wFAAwF;EACxF,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;EAIE,2CAA2C;EAC3C,0FAA0F;EAC1F,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,2CAA2C;EAC3C,gFAAgF;AAClF;;AAEA;;EAEE,2BAA2B;EAC3B,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE;;;;4CAIwC;EAC1C;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,+CAA+C;EACjD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".wallet-hub-page {\n  min-height: 100vh;\n  min-height: 100dvh;\n  padding:\n    calc(18px + var(--app-safe-top, 0px))\n    calc(18px + var(--app-safe-right, 0px))\n    calc(36px + var(--app-safe-bottom, 0px))\n    calc(18px + var(--app-safe-left, 0px));\n  position: relative;\n  overflow-x: hidden;\n  color: #f5f0e5;\n  background:\n    radial-gradient(circle at top center, rgba(53, 109, 92, 0.26) 0%, rgba(7, 19, 27, 0) 34%),\n    radial-gradient(circle at 20% 80%, rgba(240, 202, 115, 0.1) 0%, rgba(7, 19, 27, 0) 28%),\n    linear-gradient(180deg, #07131b 0%, #0b1d29 52%, #04080c 100%);\n}\n\n.wallet-hub-page__texture {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.015) 1px, transparent 1px);\n  background-size: 18px 18px;\n  mask-image: radial-gradient(circle at center, rgba(0, 0, 0, 0.88) 35%, transparent 100%);\n  opacity: 0.65;\n}\n\n.wallet-hub-topbar,\n.wallet-hub-main {\n  position: relative;\n  z-index: 1;\n}\n\n.wallet-hub-topbar {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.wallet-hub-topbar__back,\n.wallet-hub-topbar__logout,\n.wallet-hub-summary__card,\n.wallet-hub-action {\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: linear-gradient(180deg, rgba(14, 24, 31, 0.94) 0%, rgba(8, 15, 22, 0.98) 100%);\n  color: #f5f0e5;\n  border-radius: 22px;\n}\n\n.wallet-hub-topbar__back {\n  min-height: 42px;\n  padding: 0 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.84rem;\n  cursor: pointer;\n}\n\n.wallet-hub-topbar__logout {\n  min-height: 42px;\n  padding: 0 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.84rem;\n  cursor: pointer;\n}\n\n.wallet-hub-main {\n  display: grid;\n  gap: 14px;\n}\n\n.wallet-hub-summary__card span {\n  color: #f0ca73;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  font-size: 0.62rem;\n}\n\n.wallet-hub-banner {\n  padding: 12px 14px;\n  border-radius: 14px;\n  border: 1px solid transparent;\n}\n\n.wallet-hub-banner--error {\n  color: #ffd3cc;\n  background: rgba(255, 127, 114, 0.08);\n  border-color: rgba(255, 127, 114, 0.18);\n}\n\n.wallet-hub-summary {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 12px;\n}\n\n.wallet-hub-summary__card {\n  padding: 16px;\n  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.28);\n}\n\n.wallet-hub-summary__card--club {\n  display: grid;\n  gap: 12px;\n}\n\n.wallet-hub-summary__club,\n.wallet-hub-summary__wallet {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.wallet-hub-summary__club span,\n.wallet-hub-summary__wallet span {\n  color: #f0ca73;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  font-size: 0.62rem;\n}\n\n.wallet-hub-summary__club strong {\n  font-size: 0.96rem;\n  line-height: 1.2;\n  text-align: right;\n}\n\n.wallet-hub-summary__wallet strong {\n  font-size: clamp(1.1rem, 3.8vw, 1.5rem);\n  line-height: 1.1;\n  text-align: right;\n}\n\n.wallet-hub-actions {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n.wallet-hub-action {\n  width: 100%;\n  min-height: 76px;\n  padding: 14px;\n  display: grid;\n  grid-template-columns: 34px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.28);\n  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.wallet-hub-action:hover,\n.wallet-hub-action:focus-visible {\n  transform: translateY(-1px);\n  border-color: rgba(49, 230, 164, 0.22);\n  box-shadow: 0 22px 38px rgba(0, 0, 0, 0.34);\n}\n\n.wallet-hub-action__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.wallet-hub-action__icon svg,\n.wallet-hub-action > svg {\n  width: 18px;\n  height: 18px;\n}\n\n.wallet-hub-action__icon--deposit {\n  color: #31e6a4;\n}\n\n.wallet-hub-action__icon--withdraw {\n  color: #f0ca73;\n}\n\n.wallet-hub-action__copy {\n  display: grid;\n  gap: 2px;\n  min-width: 0;\n}\n\n.wallet-hub-action__copy strong {\n  font-size: 0.96rem;\n  line-height: 1.1;\n  letter-spacing: -0.01em;\n}\n\n.wallet-hub-action__copy span {\n  color: rgba(233, 238, 241, 0.64);\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n}\n\n.wallet-hub-action > svg:last-child {\n  color: rgba(233, 238, 241, 0.62);\n}\n\n.wallet-hub-action p {\n  display: none;\n}\n\n.wallet-hub-action--deposit {\n  border-color: rgba(49, 230, 164, 0.22);\n}\n\n.wallet-hub-action--withdraw {\n  border-color: rgba(240, 202, 115, 0.18);\n}\n\n@media (max-width: 720px) {\n  .wallet-hub-page {\n    padding:\n      calc(12px + var(--app-safe-top, 0px))\n      calc(12px + var(--app-safe-right, 0px))\n      calc(18px + var(--app-safe-bottom, 0px))\n      calc(12px + var(--app-safe-left, 0px));\n  }\n\n  .wallet-hub-topbar {\n    margin-bottom: 12px;\n  }\n\n  .wallet-hub-topbar__back,\n  .wallet-hub-topbar__logout {\n    min-height: 40px;\n    padding: 0 12px;\n    font-size: 0.8rem;\n  }\n\n  .wallet-hub-hero h1 {\n    font-size: clamp(1.3rem, 5.8vw, 1.85rem);\n  }\n\n  .wallet-hub-action {\n    min-height: 72px;\n    padding: 12px;\n    grid-template-columns: 32px minmax(0, 1fr) auto;\n  }\n\n  .wallet-hub-action__icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 11px;\n  }\n\n  .wallet-hub-action__copy strong {\n    font-size: 0.92rem;\n  }\n\n  .wallet-hub-action__copy span {\n    font-size: 0.68rem;\n  }\n\n  .wallet-hub-summary__card {\n    padding: 14px;\n  }\n\n  .wallet-hub-summary__club strong {\n    font-size: 0.9rem;\n  }\n\n  .wallet-hub-summary__wallet strong {\n    font-size: 1.15rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
